import _freeGlobal from "./_freeGlobal";
var exports = {};
var freeGlobal = _freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == "object" && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function("return this")();
exports = root;
export default exports;